import React from "react"
import { Select } from "components/Shared/Select"
import { useIntl } from "react-intl"
import { SelectPenetrationProps } from "./interfaces"
import { createOptionsMetricSelect, PENETRATION_OPTIONS } from "./utils"
import { SELECT_PENETRATION_TITLE_ID } from "../../constants"
import withVisibility from "components/Shared/Hocs/withVisibility"
import "./SelectPenetration.scss"

const SelectPenetration: React.FC<SelectPenetrationProps> = (props) => {
	const { onPenetrationChange, value } = props
	const intl = useIntl()

	return (
		<div data-testid="penetration-select" className="penetration-select">
			<Select
				className="select"
				id="select-penetration"
				value={value}
				options={createOptionsMetricSelect(PENETRATION_OPTIONS, intl)}
				label={intl.formatMessage({
					id: SELECT_PENETRATION_TITLE_ID,
				})}
				onChange={(option) => {
					return onPenetrationChange(option.code)
				}}
			/>
		</div>
	)
}

export default withVisibility(SelectPenetration)
